import React from "react";
import Products from "../components/Products/Products";
import Banner from "../components/Banner/Banner";

export default function Home() {
  return (
    <>
      <Banner />
      <Products />
    </>
  );
}
